import styled from '@emotion/styled';

import { Grid, Card, CardHeader, CardContent, CardActions, Button, Typography } from '@mui/material';

import { CardBlockContainer, CardBlock, CardBlockHeader, CardSpacer } from '../../../utils/utilities/CardComponents';

import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import AccountBoxOutlinedIcon from '@mui/icons-material/AccountBoxOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';

import { BasicFlex, Notes } from '../../../utils/Common';

// use pageData context
import { usePageData } from '../../../contexts/PageData';

const ProfileTab = () => {
  const { data = {} } = usePageData();

  const detailsBlock = [
    {header: "Name", icon: <AccountBoxOutlinedIcon fontSize='small' />, info: data.full_name},
    {header: "Email", icon: <EmailOutlinedIcon fontSize='small' />, info: data.email},
    {header: "Mobile", icon: <PhoneOutlinedIcon fontSize='small' />, info: data.mobile_phone},
  ];

  const activityBlock = [
    {header: "Active", info: data.is_active, dataType: "boolean", booleanValues: ["Active", "Inactive"]},
    {header: "Date Created", info: data.created_at, dataType: "date"},
  ];

  return (
    <Grid container spacing={3}>
      <Grid size={{xs: 12, md: 4}}>
        <Card variant='outlined'>
          <CardHeader title="Basic Details" />
          <CardContent>
            <CardBlockContainer>
              <CardSpacer />
              <CardBlockHeader>Contact Information</CardBlockHeader>
              {detailsBlock.map((block) => (
                <CardBlock key={block.header} {...block} />
              ))}
              <CardSpacer />

              <CardSpacer />
              <CardBlockHeader>Activity</CardBlockHeader>
              {activityBlock.map((block) => (
                <CardBlock key={block.header} {...block} />
              ))}

              <CardSpacer />
              <CardBlockHeader>Notes</CardBlockHeader>
              <Notes>{data.notes}</Notes>
        
            </CardBlockContainer>
          </CardContent>
        </Card>
      </Grid>

      <Grid size={{xs: 12, md: 8}}>
        <Card variant='outlined'>
          <CardHeader title={<BasicFlex gap="1rem">Specialist History <HistoryRoundedIcon /></BasicFlex>} />
          <CardContent>
            Timeline goes here
          </CardContent>
        </Card>
      </Grid>
 
    </Grid>
  );

};

export default ProfileTab;